<div class="wrapper d-flex flex-column align-items-center h-100 w-100">
	<h2 class="title">You’re on your way!</h2>

	<img class="mb-2" src="/assets/icons/running_man.svg" alt="running man icon" width="37" height="37" />

	<p class="text text-center">
		We’ve received your request and will be in touch within the next few days to get you started.
	</p>

	<div class="mt-auto d-flex justify-content-center">
		<button type="button" class="btn btn-confirm" (click)="close()">Close</button>
	</div>
</div>
